export default "__VITE_ASSET___wBDAKu6__"